module.exports = __webpack_public_path__ + "pivot-webfont.4751f21f1fdb239ca708.svg";


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/assets/webix/fonts/pivot-webfont.svg
// module id = ../../../../../src/assets/webix/fonts/pivot-webfont.svg
// module chunks = styles